export type ScenarioTemplateSummary = {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly ruleset: string;
};

/**
 * Fetch the list of registered ScenarioTemplates from the kernel via the
 * web proxy. Wraps `GET /api/scenario-templates` which in turn reads the
 * `verderem://scenario-templates` MCP resource (LAF-218 — wizard scenario
 * list refactor; replaces the hardcoded SCENARIO_TEMPLATES const).
 */
export async function fetchScenarioTemplates(): Promise<
  ScenarioTemplateSummary[]
> {
  const res = await fetch("/api/scenario-templates");
  if (!res.ok) {
    throw new Error("Failed to fetch scenario templates");
  }
  return res.json();
}
